export default state => {
  return state
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/getters/ccEmail.js